import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import profile from './modules/profile'
import label from './modules/label'
import page from './modules/page'
import system from './modules/system'
import account from './modules/account'

export default new Vuex.Store({
  modules: {
    profile,
    label,
    page,
    system,
    account,

    // Empty module for the apps to dynamically add too
    // Required as Vuex doesn't want to add to an empty parent module...
    apps: {
      namespaced: true
    }
  }
})
